/* eslint-disable @typescript-eslint/no-var-requires */
import React, { useState } from 'react';
import ImgPoint from '../../../../../assets/animation_point.gif';
import ImgStepC1 from '../../../../../assets/step-c-1.png';
import ImgStepC2 from '../../../../../assets/step-c-2.png';
import ImgStepC3 from '../../../../../assets/step-c-3.png';
import ImgArrowLeft from '../../../../../assets/arrow-left-long.png';
import ImgArrowRight from '../../../../../assets/arrow-right-long.png';
import Img1 from '../../../../../assets/animation004-1.png';
import './animation004.less';
import './animation004.mobile.less';
import { Button, Modal } from 'antd';

const ImgStep = [ImgStepC1, ImgStepC2, ImgStepC3];

interface IAnimation004SubItem {
  img: string;
  title: string;
  content: string;
  tip: string;
}
interface IStep {
  title: React.ReactNode | string;
  text: React.ReactNode | string;
  subStep?: React.ReactNode | string;
  tip?: string;
  subtitle?: string;
  subItems?: IAnimation004SubItem[];
}

interface IAnimation004Props {
  title: React.ReactNode | string;
  steps: IStep[];
  onCompleted?: (() => void) | null;
  style?: React.CSSProperties;
  noIndicator?: boolean | null;
  className: string;
}

const Animation004: React.FunctionComponent<IAnimation004Props> = ({
  title,
  steps,
  onCompleted,
  style,
  noIndicator,
  className,
}) => {
  const [step, setStep] = React.useState(1);
  const [subStepStatus, setSubStepStatus] =
    React.useState<Record<string, boolean>>();
  const [modalItem, setModalItem] = React.useState<IAnimation004SubItem[]>();
  const [isModalOpen, setModalOpen] = useState(false);
  const [currPage, setCurrPage] = React.useState(0);
  const [show, setShow] = useState<number[]>([]);
  const [show1, setShow1] = React.useState<number[]>([]);
  const [show2, setShow2] = React.useState<number[]>([]);
  const setPage = (pagePlus: number) => {
    setCurrPage(currPage + pagePlus);
  };
  const nextStep = () => {
    const current = step;
    if (subStepStatus && subStepStatus[current] === false) {
      return;
    }

    setStep(current + 1);
    if (current >= steps.length - 1) {
      onCompleted && onCompleted();
    }
  };

  const handleSubStepClick = (event: Event, currentStep: number) => {
    if (event && currentStep) {
      const updatedStatus = Object.assign({}, subStepStatus);
      updatedStatus[currentStep] = true;
      setSubStepStatus(updatedStatus);
    }
  };

  React.useEffect(() => {
    const subStepStatusList: Record<string, boolean> = {};
    const subStepList: number[] = [];
    steps.forEach((i, index) => {
      if (i.subStep) {
        subStepStatusList[index + 1] = false;
        subStepList.push(index + 1);
      }
    });
    setSubStepStatus(subStepStatusList);

    const subTasks = document.querySelectorAll('.sub-task-text');
    if (subTasks) {
      subTasks.forEach((task, index) =>
        task.addEventListener('click', (event: Event) =>
          handleSubStepClick(event, subStepList[index])
        )
      );
      return () =>
        subTasks.forEach((task, index) =>
          task.removeEventListener('click', (event: Event) =>
            handleSubStepClick(event, subStepList[index])
          )
        );
    }
  }, []);

  const calcPointPosition = () => {
    const styles: Record<string, any> = {
      left:
        window.innerWidth > 1024
          ? step === 1
            ? '180px'
            : step === 2
            ? '445px'
            : '725px'
          : step === 1
          ? '20vw'
          : step === 2
          ? '45vw'
          : '70vw',
      opacity: step > steps.length - 1 ? 0 : 1,
    };
    if (window.innerWidth > 1024) {
      let bottom = step === 1 ? 30 : step === 2 ? 90 : 140;
      if (subStepStatus && subStepStatus[step] === false) {
        bottom += 80;
      }
      styles.bottom = `${bottom}px`;
    } else {
      let bottom = step === 1 ? 10 : step === 2 ? 15 : 20;
      if (subStepStatus && subStepStatus[step] === false) {
        bottom = 0;
      }
      styles.bottom = `${bottom}vw`;
    }
    return styles;
  };

  return (
    <>
      <div
        className={`animation004 ${className} component ${
          !title ? 'no-title' : ''
        }`}
        style={{ ...style }}
      >
        {title && (
          <>
            <img className="img-g5584" width="214px" src={Img1} alt="" />
            {typeof title === 'string' ? (
              <div
                className="animation004-title"
                dangerouslySetInnerHTML={{ __html: title }}
              />
            ) : (
              <div className="animation004-title">{title}</div>
            )}
          </>
        )}
        <div
          className="four-steps-section four-steps-section-1200"
          style={{ marginLeft: title ? '225px' : '8vw' }}
        >
          <img
            className="click-point"
            onClick={() => nextStep()}
            style={calcPointPosition()}
            src={ImgPoint}
            alt=""
          />
          {steps.map((itm, idx) => (
            <div
              key={idx}
              className={`step step${idx + 1} animation ${
                step > idx ? 'fade-in' : ''
              }`}
              onClick={() => nextStep()}
            >
              {!noIndicator &&
                (typeof itm.title === 'string' ? (
                  <div
                    className="step-title"
                    dangerouslySetInnerHTML={{ __html: itm.title || '' }}
                  />
                ) : (
                  <div className="step-title">{itm.title}</div>
                ))}
              {typeof itm.text === 'string' ? (
                <div
                  className="text"
                  dangerouslySetInnerHTML={{ __html: itm.text || '' }}
                />
              ) : (
                <div className="text">{itm.text}</div>
              )}
              {itm.subtitle ? (
                <div className="text sub-task-text">
                  <Button
                    className="view-more-btn"
                    onClick={() => {
                      setModalOpen(true);
                      setModalItem(itm.subItems);
                      setShow([...show, idx]);
                    }}
                    type="link"
                  >
                    {itm.subtitle}
                    <img
                      className="click-point1"
                      hidden={show.includes(idx)}
                      src={ImgPoint}
                      alt=""
                    />
                  </Button>
                </div>
              ) : null}
              {!noIndicator && <div className="indicator">0{idx + 1}</div>}
              {noIndicator && (
                <div className="indicator indicator-title">{itm.title}</div>
              )}
              {idx > 0 && (
                <img
                  className={`${noIndicator ? 'no-indicator' : ''}`}
                  src={ImgStep[idx - 1]}
                  alt=""
                />
              )}
            </div>
          ))}
        </div>
      </div>
      {modalItem && (
        <Modal
          width="80%"
          className="animation011-modal-student"
          title={
            <div className="animation011-modal-header">
              {modalItem[currPage]?.title}
            </div>
          }
          footer={null}
          open={isModalOpen}
          onCancel={() => {
            setModalOpen(false);
            setCurrPage(0);
          }}
        >
          <div className="border">
            <img
              src={
                require(`../../../../../assets/${modalItem[currPage]?.img}`)
                  .default
              }
              alt=""
            />
          </div>
          {modalItem.length > 0 && modalItem[currPage]?.content && (
            <>
              <div
                className="tip"
                dangerouslySetInnerHTML={{
                  __html: modalItem[currPage]?.tip,
                }}
              />
              <div
                className="content"
                dangerouslySetInnerHTML={{
                  __html: modalItem[currPage]?.content,
                }}
              />
            </>
          )}
          <Button
            className={`prev-button ${currPage === 0 ? 'hide' : ''}`}
            type="text"
            disabled={currPage === 0}
            onClick={() => {
              setPage(-1);
              setShow2([...show2, currPage]);
            }}
          >
            <img className="arrow" src={ImgArrowLeft} alt="" />
            <img
              className="click-point1"
              hidden={!show}
              src={ImgPoint}
              alt=""
            />
          </Button>

          <Button
            className={`next-button ${
              currPage === modalItem.length - 1 ? 'hide' : ''
            }`}
            type="text"
            disabled={currPage === modalItem.length - 1}
            onClick={() => {
              setPage(1);
              setShow1([...show1, currPage]);
            }}
          >
            <img className="arrow" src={ImgArrowRight} alt="" />
            <img
              className="click-point2"
              hidden={show1.includes(currPage)}
              src={ImgPoint}
              alt=""
            />
          </Button>
        </Modal>
      )}
    </>
  );
};

Animation004.defaultProps = {
  onCompleted: null,
  style: {},
  noIndicator: false,
};

export default Animation004;
